import { titleApi } from 'store/api/titleApi';
import { projectApi } from 'store/api/projectApi';

/**
 * Middleware that keeps the RTK Query caches in sync when
 * other slices (CCB, project) dispatch actions that affect cached data.
 */
const titleCacheInvalidationMiddleware = (storeApi) => (next) => (action) => {
    const result = next(action);

    // When CCB mutations complete, patch the affected title in cache
    if (
        action.type.includes('ccb/update/fulfilled') ||
        action.type.includes('ccb/serve/fulfilled') ||
        action.type.includes('ccb/serve/agent/fulfilled')
    ) {
        const updatedTitle = action.payload?.title;
        if (updatedTitle?.id) {
            // Patch single-title cache
            storeApi.dispatch(
                titleApi.util.updateQueryData('getTitle', { id: updatedTitle.id }, (draft) => {
                    Object.assign(draft, updatedTitle);
                })
            );
            // Patch list cache
            storeApi.dispatch(
                titleApi.util.updateQueryData('getTitles', {}, (draft) => {
                    if (draft?.titles) {
                        const idx = draft.titles.findIndex((t) => t.id === updatedTitle.id);
                        if (idx !== -1) Object.assign(draft.titles[idx], updatedTitle);
                    }
                })
            );
        }
    }

    // When a project is deleted, refetch all title lists and project list
    if (action.type.includes('project/delete/fulfilled')) {
        storeApi.dispatch(titleApi.util.invalidateTags([{ type: 'TitleList', id: 'ALL' }]));
        storeApi.dispatch(projectApi.util.invalidateTags([{ type: 'ProjectList', id: 'ALL' }]));
    }

    // When a project is created or updated, refetch project list
    if (action.type === 'project/create' || action.type.includes('project/update/fulfilled')) {
        storeApi.dispatch(projectApi.util.invalidateTags([{ type: 'ProjectList', id: 'ALL' }]));
    }

    // When titles are created/deleted/bulk-updated, project title counts change
    if (
        action.type.includes('titleApi/executeMutation/fulfilled') &&
        (action.meta?.arg?.endpointName === 'createTitle' ||
            action.meta?.arg?.endpointName === 'deleteTitle' ||
            action.meta?.arg?.endpointName === 'bulkCreateTitles')
    ) {
        storeApi.dispatch(projectApi.util.invalidateTags([{ type: 'ProjectList', id: 'ALL' }]));
    }

    return result;
};

export default titleCacheInvalidationMiddleware;
